import React from "react"
import PostsGallery, { PostsGalleryProps } from './PostsGallery';
import useWindowDimensions from "../../../utils/useWindowsDimensions";
import {widthBreakpointSizes} from "../../../utils/useResponsiveMask";
            
const ResponsivePostsGallery: React.FC<PostsGalleryProps> = ( props ) => {
    const { width } = useWindowDimensions();
    const properties = {
        ...props,
        posts: props.posts.slice(0, (width >= widthBreakpointSizes.lg ? 
            props.posts.length : width >= widthBreakpointSizes.md ? 4 : 3))
    };
    return (
        <PostsGallery { ...properties } />
    );
}
            
export default ResponsivePostsGallery;
